import {
    Box,
    FormControl,
    FormHelperText,
    MenuItem,
    Select,
    Typography
} from "@mui/material";
import {
    Dispatch,
    SetStateAction
} from "react";

import { DailyRecurrence } from "../../models";
import React from "react";

type DailyRecurrenceFormProps = {
    dailyRecurrence: DailyRecurrence;
    setDailyRecurrence: Dispatch<SetStateAction<DailyRecurrence>>;
    error: Record<keyof DailyRecurrence, string> | undefined;
};

export const DailyRecurrenceForm = ({ dailyRecurrence, setDailyRecurrence, error }: DailyRecurrenceFormProps) => {
    return (
        <>
            <Typography>Every</Typography>
            <Box display="flex" gap={1} alignItems="center">
                <FormControl error={!!error?.interval}>
                    <Select
                        id="dailyInterval"
                        name="dailyInterval"
                        value={dailyRecurrence.interval ?? 1}
                        onChange={(e) => setDailyRecurrence(prev => ({ ...prev, interval: parseInt(e.target.value as string) }))}
                        variant="standard"
                        MenuProps={{
                            sx: {
                                maxHeight: 250
                            }
                        }}
                    >
                        {Array(99).fill(0).map((_, i) => (
                            <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
                        ))}
                    </Select>
                    <FormHelperText>{error?.interval}</FormHelperText>
                </FormControl>
                <Typography>day(s)</Typography>
            </Box>
        </>
    );
};